import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Label, Paragraph, Subheading } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import Role from './Role';
import RolePlaceholder from './RolePlaceholder';
import RoleEdge from './RoleEdge';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Managers(props: { user?: graphql.User; refetch: () => Promise<any> }) {
	const { t } = useTranslation();

	return (
		<Flex alignItems="flex-end">
			<Box flexGrow={0} flexShrink={0} width={200}>
				<Subheading mb={1}>{t('employees.settings.roles.managers.title')}</Subheading>
				{props.user ? (
					<Paragraph>
						{t('employees.settings.roles.managers.description', { name: props.user.firstName })}
					</Paragraph>
				) : (
					<Paragraph.Skeleton lines={3} />
				)}
			</Box>
			<Box flexGrow={1} flexShrink={1} />
			<Box flexGrow={0} flexShrink={0} width={180 * 2 + 8}>
				<Flex alignItems="flex-end">
					<Box mr={2} flexShrink={0} width={180}>
						<Label mb={1}>{t('employees.settings.roles.managers.departmentManagers')}</Label>
						{props.user ? (
							props.user.group.managers.edges.map(({ node, role }) => (
								<Box mb={1} key={node.id}>
									<Role
										inverse
										transitive
										me={props.user!}
										user={node as graphql.User}
										role={role as graphql.Role}
										refetch={props.refetch}
									/>
								</Box>
							))
						) : (
							<Box mb={1}>
								<Role.Skeleton />
							</Box>
						)}
						<Box style={{ position: 'relative' }}>
							<RoleEdge from={[90, 8]} to={[90 + 36 + 16, 96]} dashed bend="out" />
						</Box>
					</Box>
					<Box flexShrink={0} width={180}>
						<Label mb={1}>{t('employees.settings.roles.managers.oneOnOne')}</Label>
						{props.user ? (
							<>
								<Box mb={1}>
									<RolePlaceholder type="user" user={props.user} inverse refetch={props.refetch} />
								</Box>
								{props.user.individualManagers.map((role) => (
									<Box mb={1} key={role.source!.id}>
										<Role
											inverse
											indirect={role.isIndirect}
											me={props.user!}
											user={role.source}
											role={role.role as graphql.Role}
											refetch={props.refetch}
										/>
									</Box>
								))}
							</>
						) : (
							<Box mb={1}>
								<Role.Skeleton />
							</Box>
						)}
						<Box style={{ position: 'relative' }}>
							<RoleEdge from={[90, 8]} to={[36, 96]} bend="out" />
						</Box>
					</Box>
				</Flex>
			</Box>
			<Box flexGrow={1} flexShrink={1} />
		</Flex>
	);
}
